/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CodeRequest } from '../models/CodeRequest';
import type { URLData } from '../models/URLData';
import type { WalletTwoUserModel } from '../models/WalletTwoUserModel';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class WalletTwoService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns WalletTwoUserModel
     * @throws ApiError
     */
    public walletTwoRetrieve(): CancelablePromise<WalletTwoUserModel> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/wallet-two/',
        });
    }
    /**
     * Uses sent code to authenticate as a user and get user data including wallet address
     * @returns WalletTwoUserModel
     * @throws ApiError
     */
    public walletTwoCreateCreate({
        requestBody,
    }: {
        requestBody: CodeRequest,
    }): CancelablePromise<WalletTwoUserModel> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/wallet-two/create',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns URLData
     * @throws ApiError
     */
    public walletTwoGetLoginUrlRetrieve({
        redirectPath,
    }: {
        /**
         * Redirect path to be appended to the base URL
         */
        redirectPath: string,
    }): CancelablePromise<URLData> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/wallet-two/get-login-url',
            query: {
                'redirect_path': redirectPath,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public walletTwoRemoveDestroy(): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/wallet-two/remove',
        });
    }
}
